<template>
    <el-dialog title="编辑" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <el-form label-position="top" label-width="80px" ref="form" :model="form">
            <el-form-item v-if="type === 'allowe_min_score'" label="创建最低评分:">
                <el-input v-model="form.value" @keyup.native="keyupAmount" placeholder="请输入创建最低评分"></el-input>
            </el-form-item>
            <el-form-item v-if="type === 'free_optimize_count'" label="免费优化次数:">
                <el-input v-model="form.value" @keyup.native="keyupAmount" placeholder="请输入免费优化次数"></el-input>
            </el-form-item>
            <el-form-item v-if="type === 'free_score_count'" label="免费获取评分次数:">
                <el-input v-model="form.value" @keyup.native="keyupAmount" placeholder="请输入免费获取评分次数"></el-input>
            </el-form-item>
            <el-form-item v-if="type === 'free_imagine_count'" label="免费生成图片次数:">
                <el-input v-model="form.value" @keyup.native="keyupAmount" placeholder="免费生成图片次数"></el-input>
            </el-form-item>
            <el-form-item v-if="type === 'score_points'" label="评分消耗积分:">
                <el-input v-model="form.value" @keyup.native="keyupAmount" placeholder="请输入评分消耗积分"></el-input>
            </el-form-item>
            <el-form-item v-if="type === 'optimize_points'" label="优化消耗积分:">
                <el-input v-model="form.value" @keyup.native="keyupAmount" placeholder="请输入优化消耗积分"></el-input>
            </el-form-item>
            <el-form-item v-if="type === 'imagine_points'" label="生成图片消耗积分:">
                <el-input v-model="form.value" @keyup.native="keyupAmount" placeholder="生成图片消耗积分"></el-input>
            </el-form-item>
            <el-form-item v-if="type === 'commission_reward'" label="邀请返佣奖励:">
                <el-input v-model="form.value" @keyup.native="keyupAmount" placeholder="邀请返佣奖励"></el-input>
            </el-form-item>
            <template v-if="type === 'commission_reward_rate'">
                <el-form-item label="受邀人占比:">
                    <el-input v-model="form.self" @keyup.native="keyupAmount" placeholder="受邀人占比"></el-input>
                </el-form-item>
                <el-form-item label="邀请人占比:">
                    <el-input v-model="form.inviter" @keyup.native="keyupAmount" placeholder="邀请人占比"></el-input>
                </el-form-item>
            </template>
            <el-form-item>
                <el-button type="primary" :loading="loading" @click="onSubmit">立即更新</el-button>
                <el-button @click="handleClose">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import serverApi from '../../../server/index';
export default {
    props: ['dialogVisible', 'type'],
    data() {
        return {
            form: {},
            loading: false,
        };
    },
    methods: {
        keyupAmount() {
            if (this.form.value.toString().length > 0) {
                this.form.value = Number(this.form.value.toString().replace(/[^\d]/g, ''));
            }
        },
        async onSubmit() {
            try {
                let params = {};

                if (this.type === 'commission_reward_rate') {
                    if (!this.form.self || !this.form.inviter) throw new Error('请输入表单信息');
                    params = { key: this.type, value: `${this.form.self}_${this.form.inviter}` };
                } else {
                    if (!this.form.value) throw new Error('请输入表单信息');
                    params = { key: this.type, value: Number(this.form.value) };
                }
                this.loading = true;
                const result = await serverApi.updataConfig(params);
                if (result.data.code !== 0) throw new Error(result.data.error);
                this.$message({
                    message: 'Update success',
                    type: 'success',
                });
                this.$emit('closeModal', true);
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },
        handleClose() {
            this.$emit('closeModal', false);
        },
    },
};
</script>

<style></style>
